import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id B3B33DCF-9627-4286-8D43-674E066D5CF8
 * name clock-time-nine-outline
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/clock-time-nine-outline.svg
 * tags
 * - Date / Time 
 */
export const ClockTimeNineOutlineIcon = createSvgIcon(<><path d="M12 20C16.4 20 20 16.4 20 12S16.4 4 12 4 4 7.6 4 12 7.6 20 12 20M12 2C17.5 2 22 6.5 22 12S17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2M12.5 7V13H7V11.5H11V7H12.5Z" /></>, 'ClockTimeNineOutlineIcon');
export default ClockTimeNineOutlineIcon